var catchError = function catchError(error) {
  if (error.response) {
    return {
      status: error.response.status,
      error: error.response.data.message
    };
  }

  if (error.request) {
    return {
      status: error.request.status,
      error: error.request.responseText
    };
  }

  return {
    status: -1,
    error: error.message
  };
};

export { catchError };